module.exports = __webpack_public_path__ + "img/NI.520d3f24.svg";